import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
export class DocumentsCountBaseValueConverter {
    toView(documentList: Array<Object>, discussionMessageId: number) {
        //console.log(111, 'DocumentsCountBaseValueConverter', documentList, discussionMessageId);
        let count = 0;
        if (ObjectHelper.ArrayIs(documentList)) {
            count = documentList.length;
            if (ObjectHelper.ObjectIs(discussionMessageId) && discussionMessageId > 0) {
                count = documentList.filter((item) => (item['DiscussionMessage_FK'] == discussionMessageId &&  item['Deleted'] == false)).length;
            }
        }
        return count;
    }
}